export const WRITING_EVALUATOR_VIDEO_ID_ET = 'ZRo6XZ9KDAk';
export const WRITING_EVALUATOR_VIDEO_ID_EN = '6BAVIIrHe7Q';

export const TEXT_QUERY_VIDEO_ID_ET = '3SjjRS3Nt4A';
export const TEXT_QUERY_VIDEO_ID_EN = 'qk2RRceVyFY';

export const WORDLIST_VIDEO_ID_ET = 'RINeef6jVvQ';
export const WORDLIST_VIDEO_ID_EN = 'tUKr3hsNBOQ';

export const WORD_CONTEXT_VIDEO_ID_ET = 'y1hgRpFh9XU';
export const WORD_CONTEXT_VIDEO_ID_EN = 'KcxP7lg-eeE';

export const NEIGHBOURING_WORDS_VIDEO_ID_ET = 'rMbSywCQbCg';
export const NEIGHBOURING_WORDS_VIDEO_ID_EN = 'w71xLvvmKMU';

export const CLUSTER_CATCHER_VIDEO_ID_ET = 'UNvJ-S_uCwU';
export const CLUSTER_CATCHER_VIDEO_ID_EN = 'KJJA8upliyc';

export const WORD_ANALYSER_VIDEO_ID_ET = '6EuP0wjcPJw';
export const WORD_ANALYSER_VIDEO_ID_EN = 'QwKlA2tJW9A';
